import React, { useState } from "react";
import AboutUsContent from "../Components/Pages/AboutUs/AboutUsContent";
import Way from "../Components/Pages/globalComponents/Way";
export default function AboutUs() {
  const [title] = useState("О нас");
  const [way] = useState(["Mary Furnitura", "О нас"]);

  return (
    <div className="AboutUs">
      <Way title={title} way={way} />
      <AboutUsContent />
    </div>
  );
}
